class ChewModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.modal = this;

    if (!this.modal) return;

    this.ingredients = {};

    document.querySelectorAll('script[type="application/json"][id^="chew-ingredients-json-"]').forEach((script) => {
      const handle = script.id.replace('chew-ingredients-json-', '');
      try {
        this.ingredients[handle] = JSON.parse(script.textContent);
      } catch (e) {
        console.error(`Failed to parse JSON for handle: ${handle}`, e);
      }
    });

    const toggles = document.querySelectorAll('.oval-element');
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        const handle = toggle.dataset.ingredientHandle;
        const imageUrl = toggle.dataset.image;
        if (handle && this.ingredients[handle]) {
          this.populateModal(this.ingredients[handle], imageUrl);
          this.openModal();
        }
      });
    });

    this.modal.querySelectorAll('[data-close-modal]').forEach((closeElement) => {
      closeElement.addEventListener('click', () => {
        this.closeModal();
      });
    });
  }

  openModal() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.modal.classList.remove('closing');
    this.modal.classList.add('open');

    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.add('closing');

    this.closeTimeout = setTimeout(() => {
      this.modal.classList.remove('open', 'closing');
      this.closeTimeout = null;

      document.body.style.overflow = '';
    }, 300);
  }

  decodeHtmlEntities(html) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  }

  generateResponsiveImageUrl(baseUrl, width) {
    if (!baseUrl) return baseUrl;

    if (baseUrl.includes('shopify.com') || baseUrl.includes('cdn.shopify.com')) {
      const urlParts = baseUrl.split('?');
      let baseUrlClean = urlParts[0];
      let queryParams = urlParts[1] || '';

      const widthPattern = /_\d+x(?=\.[^.]*$)/;
      baseUrlClean = baseUrlClean.replace(widthPattern, '');

      const lastDotIndex = baseUrlClean.lastIndexOf('.');
      if (lastDotIndex > -1) {
        const extension = baseUrlClean.substring(lastDotIndex);
        const urlWithoutExtension = baseUrlClean.substring(0, lastDotIndex);

        let finalUrl = `${urlWithoutExtension}_${width}x${extension}`;
        if (queryParams) {
          const filteredParams = queryParams.split('&').filter((param) => !param.startsWith('width='));
          if (filteredParams.length > 0) {
            finalUrl += '?' + filteredParams.join('&');
          }
        }
        return finalUrl;
      }
    }

    const urlParts = baseUrl.split('?');
    const baseUrlClean = urlParts[0];
    const queryParams = urlParts[1] || '';

    const filteredParams = queryParams.split('&').filter((param) => param && !param.startsWith('width='));
    filteredParams.push(`width=${width}`);

    return `${baseUrlClean}?${filteredParams.join('&')}`;
  }

  populateModal(data, imageUrl) {
    this.modal.querySelector('[data-title]').textContent = data.title;
    this.modal.querySelector('[data-description]').innerHTML = this.decodeHtmlEntities(data.description);
    this.modal.querySelector('[data-research]').innerHTML = this.decodeHtmlEntities(data.research);

    if (imageUrl) {
      const imageElement = this.modal.querySelector('[data-image]');
      const srcsetSizes = imageElement.dataset.srcsetSizes;

      imageElement.src = this.generateResponsiveImageUrl(imageUrl, '60');

      if (srcsetSizes) {
        const sizes = srcsetSizes.split(',').map((size) => size.trim());
        const srcsetItems = sizes.map((size, index) => {
          const multiplier = index + 1;
          const responsiveUrl = this.generateResponsiveImageUrl(imageUrl, size);
          return `${responsiveUrl} ${multiplier}x`;
        });
        imageElement.srcset = srcsetItems.join(', ');
      }
    }

    const productsWrapper = this.modal.querySelector('[data-products]');
    productsWrapper.innerHTML = '';

    if (Array.isArray(data.featured_products)) {
      data.featured_products.forEach((product) => {
        const productEl = document.createElement('div');
        productEl.className = 'chew-modal__product text--sm text--regular';

        let displayTitle = product.title;
        if (displayTitle && displayTitle.includes('for Large Breeds')) {
          displayTitle = displayTitle.replace(/\s+for Large Breeds/i, '');
        }

        productEl.innerHTML = `
          <img
            src="${product.image}"
            srcset="${product.image} 1x, ${product.image_2x} 2x, ${product.image_3x} 3x"
            alt="${displayTitle}"
            width="93"
            height="84"
            loading="lazy"
            sizes="9.3rem"
          />
          <a href="${product.url}" target="_blank"><span>${displayTitle}</span></a>
        `;
        productsWrapper.appendChild(productEl);
      });
    }
  }
}

customElements.define('chew-modal', ChewModal);
